import React from 'react'

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-400">404</h1>
        <h2 className="text-2xl font-semibold text-gray-600 mt-4">
          Agente no encontrado
        </h2>
        <p className="text-gray-500 mt-2">
          El agente que buscas no existe o está inactivo.
        </p>
        <button 
          onClick={() => window.location.href = 'https://innovagent.tech'}
          className="btn-primary mt-6"
        >
          Ir a InnovAgent
        </button>
      </div>
    </div>
  )
}

export default NotFound
